import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader, Card, CardBody } from "reactstrap";
import { sendCashFlowResumePDF } from "../../../../services/ReportService";
import { generateReportCashFlow } from "../../../../services/ReportService";
import ReactDatePicker from "react-datepicker";
import dayjs from "dayjs";
import { CDBSpinner } from "cdbreact";
import { toast } from "react-toastify";
import currencyBRFormat from "../../../../util/CurrencyUtils";

const FechamentoCaixaModal = () => {
  const [report, setReport] = useState(null);
  const [filterDate, setFilterDate] = useState(new Date());
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  function reportCashFlow() {
    setLoading(true);
    generateReportCashFlow(dayjs(filterDate).format("YYYY-MM-DD"))
      .then((response) => {
        setReport(response);
      })
      .catch((error) => {
        console.error("Erro ao gerar relatório", error);
        toast.error("Não foi possível carregar os dados.");
      })
      .finally(() => setLoading(false));
  }

  useEffect(() => {
    if (isOpen) {
      reportCashFlow();
    }
  }, [filterDate, isOpen]);

  function sendResumeToWhatsapp() {
    setLoading(true);

    report.title = dayjs(filterDate).format("DD-MM-YYYY");

    sendCashFlowResumePDF(report)
      .then((response) => {
        toast.success(response);
      })
      .catch((error) => {
        toast.error("Não foi possível enviar o Fechamento de Caixa");
        console.error(error);
      })
      .finally(() => setLoading(false));
  }

  const processReportData = (reportData) => {
    if (!reportData) return { totalIn: 0, totalOut: 0, netTotal: 0 };
    return {
      totalIn: reportData.grossRevenue || 0,
      totalOut: reportData.totalVariableExpenses || 0,
      netTotal: reportData.netRevenue || 0
    };
  }

  const { totalIn, totalOut, netTotal } = processReportData(report);

  return (
    <div>
      <button
        type="button"
        onClick={toggle}
        className="btn btn-primary fw-bold shadow d-flex align-items-center rounded-3 px-3 py-2"
      >
        <i className="fa fa-cash-register me-2"></i> Fechar Caixa
      </button>

      <Modal
        isOpen={isOpen}
        toggle={toggle}
        size="lg"
        centered
        backdrop="static"
        contentClassName="border-0 rounded-4 shadow-lg bg-light"
      >
        <ModalHeader toggle={toggle} className="border-bottom-0 pb-0 pt-4 px-4 bg-white rounded-top-4">
          <div className="d-lg-flex align-items-center w-100">
            <div className="me-auto mb-3 mb-lg-0">
              <h5 className="fw-bold mb-0">Fechamento de Caixa</h5>
              <small className="text-muted fw-normal">Resumo do fluxo financeiro</small>
            </div>
          </div>
        </ModalHeader>

        <ModalBody className="p-4">
          <div className="bg-white p-3 rounded-4 shadow-sm border border-light mb-4">
            <div className="row align-items-center">
              <div className="col-12 col-md-5 mb-2 mb-md-0">
                <label className="form-label small fw-bold text-muted text-uppercase mb-0">
                  <i className="fa fa-calendar-day me-2 text-primary"></i>
                  Data do Fechamento
                </label>
                <p className="text-muted mb-0" style={{ fontSize: '0.75rem' }}>
                  Selecione o dia para o resumo
                </p>
              </div>

              <div className="col-12 col-md-7">
                <div className="input-group border rounded-3 shadow-sm hover-shadow-transition">
                  <span className="input-group-text bg-light border-0 text-primary px-3">
                    <i className="fa fa-search"></i>
                  </span>
                  <ReactDatePicker
                    className="form-control border-0 fw-bold text-dark bg-light py-2"
                    dateFormat="dd/MM/yyyy"
                    locale="pt-BR"
                    selected={filterDate}
                    onChange={(date) => setFilterDate(date)}
                    maxDate={new Date()}
                    todayButton="Hoje"
                    required
                    containerClassName="w-100"
                  />
                </div>
              </div>
            </div>
          </div>
          {loading ? (
            <div className="d-flex flex-column align-items-center justify-content-center py-5">
              <CDBSpinner dark />
              <span className="mt-2 text-muted small fw-bold">Processando dados...</span>
            </div>
          ) : report ? (
            <div className="fade-in">

              {/* CARD DE SALDO FINAL */}
              <Card className="border-0 rounded-4 shadow-sm mb-4 bg-primary text-white overflow-hidden">
                <CardBody className="p-4 d-flex align-items-center justify-content-between">
                  <div>
                    <div className="text-uppercase small fw-bold opacity-75 mb-1" style={{ fontSize: '0.7rem' }}>
                      Saldo Final em Caixa
                    </div>
                    <h2 className="fw-bold mb-0 display-6">
                      {currencyBRFormat(netTotal)}
                    </h2>
                    <small className="opacity-75">
                      Referente a: {dayjs(filterDate).format("DD/MM/YYYY")}
                    </small>
                  </div>
                  <div className="display-1 opacity-25 d-none d-md-block">
                    <i className="fas fa-hand-holding-usd"></i>
                  </div>
                </CardBody>
              </Card>

              {/* ENTRADAS, SAÍDAS E VEÍCULOS (3 COLUNAS) */}
              <div className="row g-3 mb-4">
                <div className="col-md-4">
                  <Card className="border-0 rounded-3 shadow-sm bg-white h-100">
                    <CardBody className="p-3 d-flex align-items-center">
                      <div className="rounded-circle bg-success bg-opacity-10 text-success d-flex align-items-center justify-content-center me-3" style={{ width: '45px', height: '45px' }}>
                        <i className="fas fa-arrow-down small"></i>
                      </div>
                      <div>
                        <div className="text-muted small fw-bold text-uppercase" style={{ fontSize: '0.6rem' }}>Entradas</div>
                        <h5 className="fw-bold text-success mb-0">{currencyBRFormat(totalIn)}</h5>
                      </div>
                    </CardBody>
                  </Card>
                </div>

                <div className="col-md-4">
                  <Card className="border-0 rounded-3 shadow-sm bg-white h-100">
                    <CardBody className="p-3 d-flex align-items-center">
                      <div className="rounded-circle bg-danger bg-opacity-10 text-danger d-flex align-items-center justify-content-center me-3" style={{ width: '45px', height: '45px' }}>
                        <i className="fas fa-arrow-up small"></i>
                      </div>
                      <div>
                        <div className="text-muted small fw-bold text-uppercase" style={{ fontSize: '0.6rem' }}>Saídas</div>
                        <h5 className="fw-bold text-danger mb-0">{currencyBRFormat(totalOut)}</h5>
                      </div>
                    </CardBody>
                  </Card>
                </div>

                <div className="col-md-4">
                  <Card className="border-0 rounded-3 shadow-sm bg-white h-100">
                    <CardBody className="p-3 d-flex align-items-center">
                      <div className="rounded-circle bg-primary bg-opacity-10 text-primary d-flex align-items-center justify-content-center me-3" style={{ width: '45px', height: '45px' }}>
                        <i className="fas fa-car small"></i>
                      </div>
                      <div>
                        <div className="text-muted small fw-bold text-uppercase" style={{ fontSize: '0.6rem' }}>Veículos</div>
                        <h5 className="fw-bold text-primary mb-0">{report?.totalVehicles || 0}</h5>
                      </div>
                    </CardBody>
                  </Card>
                </div>
              </div>

              <div className="text-center pt-2">
                {!loading ? (
                  <>
                    <button
                      className="btn btn-success btn-lg rounded-pill px-4 shadow-sm d-flex align-items-center justify-content-center mx-auto w-100"
                      onClick={sendResumeToWhatsapp}
                      style={{ maxWidth: '300px' }}
                    >
                      <i className="fab fa-whatsapp me-2 fa-lg"></i>
                      <span className="fw-bold">Enviar p/ WhatsApp</span>
                    </button>
                    <p className="text-muted mt-3 mb-0" style={{ fontSize: '0.7rem' }}>
                      <i className="fa fa-info-circle me-1"></i>
                      O relatório completo será enviado em PDF para o WhatsApp da empresa.
                    </p>
                  </>
                ) : (
                  <div className="d-flex flex-column align-items-center">
                    <CDBSpinner dark />
                    <span className="small text-muted mt-2">Gerando PDF e enviando...</span>
                  </div>
                )}
              </div>

            </div>
          ) : (
            <div className="text-center p-5 bg-white rounded-4 shadow-sm border border-light">
              <i className="fas fa-search-dollar fa-3x text-muted mb-3"></i>
              <p className="text-muted m-0">Nenhum registro para esta data.</p>
            </div>
          )}
        </ModalBody>
      </Modal>
    </div>
  );
};

export default FechamentoCaixaModal;